export const REMEMBERED_TENANTS_STORAGE_KEY = 'remembered-tenants';
export const MAX_REMEMBERED_TENANTS = 10;
